import { DashboardFn } from "../../../../../rest/Dashboard/interfaces";
import { FlagActions } from "../../../../flux/Flag";
import { ErrorActions } from "../../../../flux/Error";
import { ListActions } from "../../../../flux/Grid";
import { LabelActions } from "../../../../flux/Label";
import { Polyglot } from "../../../../../polyglot";
import { Command } from "../../../../../Command";

export class LoadDashboardCommand implements Command
{
    private readonly flagActions = new FlagActions();
    private readonly errorActions = new ErrorActions();
    private readonly listActions = new ListActions();
    private readonly labelActions = new LabelActions();
    
    constructor(
        private polyglot: Polyglot,
        private getDashboard: DashboardFn, private getDivisionId: () => string|number,
        private listDispatchToken,
        private reportListDispatchToken: string, private reportTableLabelDipatchToken: string,
        private inProgressDispatchToken: string, private errorDispatchToken: string)
    {        
    }

    execute = () => {
        const divisionId = this.getDivisionId();

        this.flagActions.set(this.inProgressDispatchToken);
        this.getDashboard({ DivisionId: divisionId })
            .then(res => {
                res.SensorsExcesses.forEach(se => se.date = new Date(se.DateTime));
                this.listActions.setItems(res.SensorsExcesses, this.listDispatchToken);

                this.labelActions.set(this.polyglot.t('dashboard.summary_table.header', { name: res.Division}), this.reportTableLabelDipatchToken);
                this.listActions.setItems([res], this.reportListDispatchToken);
            })
            .catch(err => this.errorActions.setError(err, this.errorDispatchToken, 5 * 1000))
            .then(() => this.flagActions.reset(this.inProgressDispatchToken)); // finally
    }
}


// WEBPACK FOOTER //
// ./src/app/components/Pages/Home/commands/LoadDashboardCommand.ts